import React, { useState, useEffect, useRef, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { Tooltip } from '@progress/kendo-react-tooltip'
import {
  InformationADAkubicaFirmaDigitalInvitedPure,
  PromotionalFooterPure,
  GridHLPure,
  DialogSystemGLPure,
  SubtitleCustom,
  ButtonHLPure,
  DialogFormHLPure,
  GridSimpleReadHLPure,
  ValidationCodePure,
  TooltipHLPure,
  SearchBarHLPure,
  InteractiveDialog,
  InstructionsPure
} from '../../pures'
import DialogDeleteSignaturePure from '../../pures/dialog-delete-signature/dialog-delete-signature.pure'
import './signature-receive-panel.css'
import CanvasDraw from 'react-canvas-draw'
import SignatureReceiveService from '../../../services/signature-receive.service'
import { SimpleLoading } from "../../pures";
import { Context } from '../../../Context'
import { useDeviceType } from '../../../hooks'
import FirstStep from '../../features/MultipleSign/FirstStep'

const SignatureReceivePanelView = (props) => {
  const { stateSortStart, stateSortLimit } = props
  const { t } = useTranslation()

  const context = useContext(Context)
  const {
    notificationFilters,
    setSelectedFilter
  } = context

  const selectedValueFilter = notificationFilters.selectedFilter


  let edit = t('cellDetailSignatureRequest.seeDetail')
  let tooltipTracking = t('cellDetailSignatureRequest.tooltipTracking')
  let tooltipSeeDetail = t('cellDetailSignatureRequest.tooltipSeeDetail')
  let tooltipDelete = t('cellDetailSignatureRequest.tooltipCancelSignRequest')

  const [selectedItem, setSelectedItem] = useState({})
  const [selectedUser, setSelectedUser] = useState()
  const [allRequests, setAllRequests] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [requests, setRequests] = useState([])
  const pad = useRef(null)

  let infodevice = navigator.userAgent.toLowerCase()
  const { isMobile } = useDeviceType()

  const handleSearchChange = (e) => {
    const term = e.target.value
    setSearchTerm(term)
  }

  const fetchRequests = async () => {
    try {
      setIsLoading(true)
      const tokenData = JSON.parse(localStorage.getItem('token'))
      const token = tokenData?.accessToken || tokenData?.idToken
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      const params = {
        timezone,
        token,
        solicitudeName: searchTerm || undefined
      }

      switch (selectedValueFilter) {
        case 'Pendientes':
          params.inboxInvolvedType = 'received'
          break
        case 'Canceladas':
          params.status = 'Cancelado'
          break
        case 'Rechazadas':
          params.status = 'Rechazado'
          break
        case 'En progreso':
          params.inboxInvolvedType = 'sent'
          break
        case 'Completadas':
          params.inboxInvolvedType = 'completed'
          break
      }

      const signatureReceiveService = new SignatureReceiveService(process.env.REACT_APP_MIFIRMA_API)
      const response = await signatureReceiveService.getAllInbox(params)

      const formatDate = (dateStr) => {
        if (!dateStr) return ''
        const date = new Date(dateStr)
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`
      }

      const formattedRequests = (response?.data?.inboxFiltered || []).map(item => {
        const { solicitudeStartDate, solicitudeLimitDate, actionName, solicitudeStatus } = item.inbox || {}

        return {
          ...item.inbox,
          solicitudeStartDate: formatDate(solicitudeStartDate),
          solicitudeLimitDate: formatDate(solicitudeLimitDate),
          actionName: t(`signatureReceivePanelView2.${actionName}`, { defaultValue: actionName }),
          solicitudeStatus: t(`signatureReceivePanelView2.inbox.solicitudeStatus.${solicitudeStatus}`, { defaultValue: solicitudeStatus })
        }
      })

      setAllRequests(formattedRequests)

      // Extraer datos de firma por volumen y enviarlos al action
      if (props.updateVolumeData) {
        const volumeSignsRaw = (response?.data?.signaturesByVolumeFinal || [])
          .sort((a, b) => new Date(a.limitDate) - new Date(b.limitDate))

        const autographySignImg = response?.data?.autographySignImg || ''
        const canSignByVolume = Array.isArray(volumeSignsRaw) && volumeSignsRaw.length > 0
        const formattedVolumeSigns = canSignByVolume
          ? volumeSignsRaw.map((sign) => ({
            ...sign,
            limitDate: sign.limitDate ? formatDate(sign.limitDate) : '',
            subText: t('signatureReceivePanelView.subText')
          }))
          : []
        props.updateVolumeData({
          volumeSigns: formattedVolumeSigns,
          canSignByVolume,
          haveSignatures: canSignByVolume,
          signImage: autographySignImg
        })
      }
    } catch (error) {
      console.error('Error fetching requests:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const filtered = allRequests.filter(req =>
      req.solicitudeName?.toLowerCase().includes(searchTerm.toLowerCase())
    )

    const parseDate = (dateStr) => {
      if (!dateStr) return new Date(0)
      return new Date(dateStr.split('/').reverse().join('-'))
    }

    if (!stateSortStart && !stateSortLimit) {
      filtered.sort((a, b) =>
        parseDate(b.solicitudeStartDate) - parseDate(a.solicitudeStartDate)
      )
    }

    if (stateSortStart === 1) {
      filtered.sort((a, b) =>
        parseDate(b.solicitudeStartDate) - parseDate(a.solicitudeStartDate)
      )
    } else if (stateSortStart === 2) {
      filtered.sort((a, b) =>
        parseDate(a.solicitudeStartDate) - parseDate(b.solicitudeStartDate)
      )
    }

    if (stateSortLimit === 1) {
      filtered.sort((a, b) =>
        parseDate(b.solicitudeLimitDate) - parseDate(a.solicitudeLimitDate)
      )
    } else if (stateSortLimit === 2) {
      filtered.sort((a, b) =>
        parseDate(a.solicitudeLimitDate) - parseDate(b.solicitudeLimitDate)
      )
    }
    setRequests(filtered)
  }, [searchTerm, allRequests, stateSortStart, stateSortLimit])

  useEffect(() => {
    fetchRequests()
  }, [selectedValueFilter, props.refreshKey])

  const isTablet = useMediaQuery('(min-width: 950px) and (max-width: 1180px)')
  const showIconTracking = useMediaQuery('(max-width: 650px')
  const isSmallScreen = useMediaQuery('(max-width: 1181px)')
  const showActions = useMediaQuery('(max-width: 250px)')
  const longmatches = useMediaQuery('(max-width:900px)')
  const isDesktop = useMediaQuery('(min-width: 1181px)')

  const globalContainerStyles = {
    padding: '0px 20px',
    minHeight: '100%',
  }

  const containerInformationContactPlanStyles = {
    marginTop: 'auto',
    paddingTop: '20px',
    marginBottom: '20px',
  }
  const informationContactInvitedGridContainer = {
    alignItems: 'start',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff',
    marginLeft: '0px',
    marginBottom: '20px',
    boxShadow: '1px 1px 3px #959595',
    paddingLeft: '10px',
    paddingBottom: '10px',
    lineHeight: '1.1rem',
  }
  const filterContainerStyles = {
    marginTop: '7px',
    marginLeft: '75px',
  }

  const handleFilterChange = (newFilter) => {
    setSelectedFilter(newFilter)
  }

  if (longmatches) {
    filterContainerStyles.marginLeft = 0
    filterContainerStyles.marginTop = 7
  }

  return (
    <div className='standard-wrapper'>
      <Container
        spacing={4}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={globalContainerStyles}
      >
        {/* Table and Header */}

        <Grid
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className='header-inbox'>
          <SubtitleCustom
            title={t('signatureReceivePanelView.receiveRequest')}
            children={
              !props.canSignByVolume ?
                null
                : props.disabledVolumeSign ?
                  <TooltipHLPure
                    positionTooltip={'left'}
                    titleTooltip={t('signatureReceivePanel.byVolume.mainButton.title')}
                    descriptionTooltip={t('signatureReceivePanel.byVolume.mainButton.tooltip')}
                    customImg={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_multiples_firmas.svg`}
                    styleCustomImg='volumeSignIcon'
                  />
                  :
                  <img
                    onClick={!props.disabledVolumeSign ? () => props.showVolumeDialog(true) : null}
                    src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_multiples_firmas.svg`}
                    className='volumeSignIcon'
                  />
            }
          />
        </Grid>

        <div className='table-wapprer-buttons'>
          <Tooltip
            openDelay={600}
            position='top'
            anchorElement='target'
            tooltipClassName='tooltipGeneralStyle'
          >
            <button
              title={t('signatureReceivePanelView2.tooltipTabPending')}
              className={`table-filter-buttons ${selectedValueFilter === 'Pendientes' ? 'table-button-blue-active' : ''}`}
              onClick={() => handleFilterChange('Pendientes')}
            >
              <span
                className='SignatureReceivePanelView-title-filter'
                title={t('signatureReceivePanelView2.tooltipTabPending')}
              >
                {t('signatureReceivePanelView2.title.tooltip.pending')}
              </span>
            </button>
          </Tooltip>

          <Tooltip
            openDelay={600}
            position='top'
            anchorElement='target'
            tooltipClassName='tooltipGeneralStyle'
          >
            <button
              title={t('signatureReceivePanelView2.tooltipTabProcess')}
              className={`table-filter-buttons ${selectedValueFilter === 'En progreso' ? 'table-button-blue-active' : ''}`}
              onClick={() => handleFilterChange('En progreso')}
            >

              <span
                className='SignatureReceivePanelView-title-filter'
                title={t('signatureReceivePanelView2.tooltipTabProcess')}
              >
                {t('signatureReceivePanelView2.title.tooltip.process')}
              </span>
            </button>
          </Tooltip>

          <Tooltip
            openDelay={600}
            position='top'
            anchorElement='target'
            tooltipClassName='tooltipGeneralStyle'
          >
            <button
              title={t('signatureReceivePanelView2.tooltipCompleted')}
              className={`table-filter-buttons ${selectedValueFilter === 'Completadas' ? 'table-button-blue-active' : ''}`}
              onClick={() => handleFilterChange('Completadas')}
            >

              <span
                className='SignatureReceivePanelView-title-filter'
                title={t('signatureReceivePanelView2.tooltipCompleted')}
              >
                {t('signatureReceivePanelView2.title.tooltip.completed')}
              </span>
            </button>
          </Tooltip>


          {!isSmallScreen && (
            <>
              <Tooltip
                openDelay={600}
                position='top'
                anchorElement='target'
                tooltipClassName='tooltipGeneralStyle'
              >
                <button
                  title={t('signatureReceivePanelView2.tooltipCancel')}
                  className={`table-filter-buttons ${selectedValueFilter === 'Canceladas' ? 'table-button-blue-active' : ''}`}
                  onClick={() => handleFilterChange('Canceladas')}
                >
                  <span
                    className='SignatureReceivePanelView-title-filter'
                    title={t('signatureReceivePanelView2.tooltipCancel')}
                  >
                    {t('signatureReceivePanelView2.title.tooltip.cancel')}
                  </span>
                </button>
              </Tooltip>

              <Tooltip
                openDelay={600}
                position='top'
                anchorElement='target'
                tooltipClassName='tooltipGeneralStyle'
              >
                <button
                  title={t('signatureReceivePanelView2.tooltipAll')}
                  className={`table-filter-buttons ${selectedValueFilter === 'Todas' ? 'table-button-blue-active' : ''}`}
                  onClick={() => handleFilterChange('Todas')}
                >
                  <span
                    className='SignatureReceivePanelView-title-filter'
                    title={t('signatureReceivePanelView2.tooltipAll')}
                  >
                    {t('signatureReceivePanelView2.title.tooltip.all')}
                  </span>
                </button>
              </Tooltip>
            </>
          )}

          <div className='filter'>
            <SearchBarHLPure
              onSearchChange={(value) => { handleSearchChange(value) }}
              placeholder={t('digitalVaultView.title.search')}
              searchValue={searchTerm}
            />
          </div>
        </div>
        {
          isLoading ? (
            <SimpleLoading />
          ) : (
            <GridHLPure
              {...props}
              dataGrid={requests}
              skip={0}
              take={6}
              fieldSubtitle={'actionName'}
              onSelectedItem={setSelectedUser}
              selectedFilter={selectedValueFilter}
              //Primera columna
              titleRow1={t('signatureReceivePanelView2.grid.title.1')}
              fieldRow1={'solicitudeName'}
              styleCol1={'signatureReceivePanel-col1'}
              lockedColumnOne={true}
              //Segunda columna (aunque diga 3)
              columnThree={isDesktop || isTablet}
              titleRow3={t('signatureReceivePanelView2.grid.title.3')}
              fieldRow3={'solicitudeStatus'}
              styleCol2={'signatureReceivePanel-col2'}
              //Tercera columna 
              extraColumnInbox={isDesktop || isTablet}
              titleExtraColumn={t('signatureReceivePanelView2.grid.title.create.date')}
              fieldRow4={'solicitudeStartDate'}
              styleCol3={'signatureReceivePanel-col3'}
              otherExtraColumnInbox={isDesktop || isTablet}
              titleOtherExtraColumn={t('signatureReceivePanelView2.grid.title.limit.date')}
              fieldRow5={'solicitudeLimitDate'}
              featuresColumnInbox={isDesktop}
              titleFeaturesColumn={t('signatureReceivePanelView2.grid.title.characteristics')}
              fieldRow6={'solicitudeAdditionalData'}
              columnFourForInbox
              titleRow4={!showActions ? t('signatureReceivePanelView2.grid.title.actions') : ''}
              labelFourthActions={t('signatureReceivePanelView2.grid.title.detail')}
              inboxTypeCell
              styleCol4={'signatureReceivePanel-colActions'}
              widthHeaderCol4={'signatureReceivePanel-colActions'}
              stateSortStart={stateSortStart}
              stateSortLimit={stateSortLimit}
              changeSort={props.filterByState}
              tooltipDetail={tooltipSeeDetail}
              tooltipTracking={tooltipTracking}
              tooltipDelete={tooltipDelete}
              seeDetail={edit}
              labelsColumnsNoPadding
              widthHeader={'signatureReceivePanel-col1Header'}
              showTracking={showIconTracking}
              iconSubtitle
              iconField={'actionIcon'}
            />
          )
        }
        {/* Information of plan, contact and Ad */}
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          style={containerInformationContactPlanStyles}
        >
          {props.userType.id !==
            Number(Number(process.env.REACT_APP_USER_TYPE_INVITADO)) ? (
            <Grid container xs={12} lg={12} md={12} sm={12} es={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
              <PromotionalFooterPure />
            </Grid>
          ) : (
            <>
              <Grid container xs={12} lg={12} md={12} sm={12} es={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                <PromotionalFooterPure />
              </Grid>
              <Grid
                container
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                spacing={2}
                style={informationContactInvitedGridContainer}
              >
                <InformationADAkubicaFirmaDigitalInvitedPure
                  onInvitedRedirectRegister={props.onInvitedRedirectRegister}
                />
              </Grid>
            </>
          )}
        </Container>

        {/* Dialog Delete Request */}
        <DialogDeleteSignaturePure
          {...props}
          toggleDialogDeleteRequest={props.toggleDialogDeleteRequest}
          handleCommentsDelete={props.handleCommentsDelete}
          deleteSignRequest={props.deleteSignRequest}
        />

        {/* Alerts of Notification Completed and Loadign */}
        <DialogSystemGLPure
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          showLoadingRequesting={props.showLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
          showCompletedRequesting={props.showCompletedRequesting}
          showErrorRequesting={props.showErrorRequesting}
          messageComplete={props.messageComplete}
          message={props.message}
        />

        {props.showVolumeSign &&
          <InteractiveDialog
            dialogSize='M'
            containerClassName='signatureReceivePanel-dialog'
            title={t('signatureReceivePanel.byVolume.mainButton.title')}
            onClose={() => {
              props.showVolumeDialog(false)
              props.handleVerifiedNip(false)
            }}
          >
            {
              !props.verifiedNip
                ?
                <>
                  <InstructionsPure instructions={[t('signatureReceivePanelView2.multipleSign.instructions')]} />
                  <FirstStep
                    volumeSigns={props.volumeSigns}
                    nip={props.nip}
                    setNip={props.setNip}
                    showVolumeDialog={props.showVolumeDialog}
                    setVerifiedNip={props.setVerifiedNip}
                  />
                </>
                : <div className='signatureReceivePanel-body-container'>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className='canvas-draw-container'
                  >
                    <CanvasDraw
                      ref={pad}
                      className='canvas-draw-container'
                      loadTimeOffset={0}
                      lazyRadius={2}
                      brushRadius={2}
                      brushColor={'#000'}
                      catenaryColor={'#0a0302'}
                      gridColor={'rgba(150,150,150,0.17)'}
                      hideGrid
                      canvasWidth={'100%'}
                      canvasHeight={(isMobile) ? window.innerWidth / 2.09 : 300}
                      disabled
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className='signatureReceivePanel-buttons-container-volumeSign-verifiedNip'
                  >
                    <ButtonHLPure
                      nameBtn={t('button.back')}
                      onClickBtn={() => props.returnVerifyNip()}
                    />
                    <ButtonHLPure
                      nameBtn={t('button.sign')}
                      onClickBtn={() => props.signByVolume(isMobile)}
                      primary
                    />
                  </Grid>
                </div>
            }
          </InteractiveDialog>
        }
      </Container>
    </div>
  )
}

export { SignatureReceivePanelView as default }